import { Cell } from './table/Cell';
import { LIST_USAGE_TYPE, TABLE_COLUMNS } from './constants';
import { ListReference } from '../../../types';

type ListReferenceTypeCellProps = {
  listReference: ListReference;
  rowIndex: number;
};

export const testIds = {
  cell: 'segmentation-lrtc-cell',
  text: 'segmentation-lrtc-text',
};

export const ListReferenceTypeCell = ({
  listReference: dependent,
  rowIndex,
}: ListReferenceTypeCellProps) => (
  <Cell
    data-test={testIds.cell}
    columnId={TABLE_COLUMNS.TYPE}
    {...(rowIndex % 2 === 0 && { className: 'shadedRow' })}
  >
    <div data-test={testIds.text}>{LIST_USAGE_TYPE[dependent.__typename]}</div>
  </Cell>
);
